import { useState, useEffect, useContext } from 'react';
import apiUser from '../../apiUser';
import { UserContext } from '../../contexts/userProvider';
import LoadingSpinner from '../Loader/load';
import { avisoDe } from './format';

const Relatorios = () => {
    const { setAlert } = useContext(UserContext);
    const [relatorios, setRelatorios] = useState(null);

    const aviso = avisoDe(setAlert);

    useEffect(() => {
        apiUser.get('/faturamento/relatorios').then(({ data }) => {
            if (data.success) setRelatorios(data.dados || []);
            else aviso(data.message);
        }).catch(() => setRelatorios([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (relatorios === null) return <LoadingSpinner />;

    return (
        <div className='w-full'>
            {relatorios.length === 0 && (
                <p className='text-sm text-gray-500'>Nenhum relatório cadastrado.</p>
            )}
            {relatorios.map((r) => (
                <div key={r.id} className='border dark:border-gray-700 rounded-lg p-4 mb-3 flex items-center justify-between'>
                    <div>
                        <p className='font-semibold dark:text-white'>{r.nome}</p>
                        <p className='text-xs text-gray-500'>tipo: {r.tipo}</p>
                    </div>
                    {r.padrao === '1' && (
                        <span className='px-3 py-1 rounded-full text-xs font-semibold bg-vox-blue-600 text-white'>Padrão</span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Relatorios;
